export default __webpack_public_path__ + "static/media/thumbnail.6fd6cab8.jpeg";